/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Assign_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Select user" |
*
* @param {Explorer_Info_Assign_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_assign_placeholder = /** @type {((inputs?: Explorer_Info_Assign_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Assign_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionner un utilisateur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzer auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona utente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите пользователя")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar usuario")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择用户")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ユーザーを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपयोगकर्ता का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecionar usuário")
	return /** @type {LocalizedString} */ ("Select user")
});